<script lang="ts">
    
    import { Icon } from "sveltestrap";
    import SidebarBtn from "./SidebarBtn.svelte";

</script>

<SidebarBtn href="/cuentas">
    <Icon name="briefcase-fill" slot="icon" /> Cuentas
</SidebarBtn>

<SidebarBtn href="/usuarios">
    <Icon name="people" slot="icon" /> Usuarios
</SidebarBtn>
